import styles from "../../../styles/Home.module.css";
import { Container, Carousel, Row, Col, Button } from "react-bootstrap";
import { useState, useEffect } from "react";
import Image from "next/image";
import axios from "axios";
import CategoriesHeroImage from "../../../assets/Illustrations/Logos.svg";
import Form from "react-bootstrap/Form";
import CompaniesCard from "../../../components/companyCard";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import EmptyState from "../../../components/emptyState";
import Modal from "react-bootstrap/Modal";
import { useUser } from "@auth0/nextjs-auth0";
import { useRouter } from "next/router";
import Spinner from "react-bootstrap/Spinner";
import Link from "next/link";
import Head from "next/head";
import HeadComponent from "../../../components/HeadComponent";
import mongoapi from "../../api/mongoapi";
import jwt from "jsonwebtoken";
import { callBackendApi } from "@/utils/common";

const frame =
  '<iframe class="airtable-embed" frameborder="0" onmousewheel="" src="https://airtable.com/embed/shrziQ48YvSa0gacI?backgroundColor=orange"  width="100%" height="800" ></iframe> ';

function Iframe(props) {
  return (
    <div
      dangerouslySetInnerHTML={{ __html: props.iframe ? props.iframe : "" }}
    />
  );
}

function MyVerticallyCenteredModal(props) {
  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{}}
    >
      <Modal.Body className="p-0 m-0">
        <Iframe iframe={frame} />,
      </Modal.Body>
    </Modal>
  );
}

const initialState = {
  category: {},
  companies: [],
};

function Categories(props) {
  const [state, updateState] = useState(initialState);
  const [modalShow, setModalShow] = useState(false);
  const [filteredCategory, setfilteredCategory] = useState(props.companies);
  const [categoryInput, setcategoryInput] = useState();
  const user = useUser().user;
  const userLoading = useUser().isLoading;
  const userId = user ? user.sub.split("|")[1] : "null";
  const router = useRouter();

  const categorySearch = (e) => {
    filterCategory(e);
    setcategoryInput(e);
  };

  const filterCategory = (e) => {
    const Cat = props.companies.filter((item) =>
      item.companyName.toLowerCase().includes(e.toLowerCase())
    );
    setfilteredCategory(Cat);
  };

  const metaTitle = `${
    props.category && props.category.name
  } - Tools & Companies - Modern Data Stack`;
  const metaContent = `Here are some amazing companies in the ${
    props.category && props.category.name
  } category of the Modern Data Stack`;
  return (
    <div
      className={styles.container}
      style={{
        backgroundColor: "#fff7ea",
        // opacity: props.nav || props.loading ? "0.4" : "1",
      }}
    >
      <HeadComponent
        title={`${metaTitle}`}
        url={"https://www.moderndatastack.xyz"}
        description={`${metaContent}`}
      />

      <div
        style={{
          backgroundColor: "#FEEBDC",
        }}
        className="mb-5 pb-5 pt-5"
      >
        <Container>
          <Row className="justify-content-start">
            <Col sm={8} md={8} lg={8} xl={8} xxl={8} xs={12}>
              {props.width > 575 && (
                <p>
                  <span>
                    <Link href="/categories">
                      <a
                        style={{
                          color: "#f66640",
                          textDecoration: "none",
                          opacity: "0.6",
                          fontSize: "15px",
                        }}
                      >
                        Categories
                      </a>
                    </Link>
                  </span>
                  <span
                    className="m-1"
                    style={{
                      color: "#f66640",
                      textDecoration: "none",
                      fontSize: "15px",
                    }}
                  >
                    {">"}
                  </span>
                  <span>
                    <Link
                      href="/category/[id]"
                      as={`/category/${props.category.slug}`}
                    >
                      <a
                        style={{
                          color: "#f66640",
                          textDecoration: "none",
                          opacity: "0.6",
                          fontSize: "15px",
                        }}
                      >
                        {props.category.name}
                      </a>
                    </Link>
                  </span>
                  <span
                    className="m-1"
                    style={{
                      color: "#f66640",
                      textDecoration: "none",
                      fontSize: "15px",
                    }}
                  >
                    {">"}
                  </span>
                  <span
                    style={{
                      color: "#f66640",
                      textDecoration: "none",
                      fontSize: "15px",
                    }}
                  >
                    Featured Companies
                  </span>
                </p>
              )}

              <Row className="justify-content-start">
                <Col md={10} xs={12} className="justify-content-start">
                  <h1 className=" " style={{ textAlign: "start" }}>
                    Companies
                  </h1>
                </Col>
                {props.width < 575 && (
                  <Col
                    sm={4}
                    md={4}
                    lg={4}
                    xs={12}
                    style={{
                      display: "flex",
                      justifyContent: props.width < 575 ? "center" : "end",
                    }}
                    className="p-0 m-0"
                  >
                    <Image
                      height="180px"
                      width="200px"
                      src={CategoriesHeroImage}
                      alt=""
                    />
                  </Col>
                )}
                <Col md={10} xs={12}>
                  <p
                    className="text-muted font-size-lg"
                    style={{ textAlign: "start", fontSize: "18px" }}
                  >
                    Featured companies in the {props.category.name}
                  </p>
                </Col>
              </Row>
            </Col>
            {props.width > 575 && (
              <Col
                sm={4}
                md={4}
                lg={4}
                xl={4}
                xxl={4}
                style={{
                  display: "flex",
                  justifyContent: props.width < 575 ? "center" : "end",
                }}
                className="p-0 m-0"
              >
                <Image
                  height="220"
                  width="200px"
                  src={CategoriesHeroImage}
                  alt=""
                />
              </Col>
            )}
          </Row>
        </Container>
      </div>

      {props.category &&
      props.category.name &&
      props.category.name.length > 0 ? (
        <Container className="justify-content-md-center">
          <Row className="justify-content-center mb-5">
            <Col md={12} lg={12}>
              <form className="mt-8">
                <Row className="form-group row justify-content-center">
                  <Col sm={8} xs={8} lg={10} md={10} className="mt-2">
                    <input
                      className="form-control rounded-sm shadow-sm"
                      id="categorySearch"
                      onChange={(e) => categorySearch(e.target.value)}
                      placeholder="Search your keyword here"
                      style={{
                        border: "1px solid #FDE0D9",
                        backgroundColor: props.nav ? "#dcd5ca" : "#fff7ea",
                      }}
                      list="categoryList"
                    />
                  </Col>
                  <Col
                    sm={4}
                    xs={4}
                    lg={2}
                    md={2}
                    style={{ height: "40px" }}
                    className="mt-2"
                  >
                    <button
                      className="btn btn-primary rounded-sm text-center w-100 h-100"
                      style={{ backgroundColor: "#f66640", border: "#f66640" }}
                    >
                      Search
                    </button>
                  </Col>
                </Row>
              </form>
            </Col>
          </Row>

          <Row>
            <Col md={12} sm={12} lg={12} xl={12} xs={12}></Col>
          </Row>

          {props.companies.length == 0 ? (
            <EmptyState />
          ) : (
            <Row className="mb-5">
              {filteredCategory.map((company) => (
                <Col
                  md={6}
                  sm={6}
                  lg={4}
                  xl={3}
                  xs={12}
                  className="p-3 "
                  key={company.id}
                >
                  <CompaniesCard company={company} width={props.width} />
                </Col>
              ))}
            </Row>
          )}

          <Row className="justify-content-md-center mb-5 m-1 mt-5">
            <Col
              sm={12}
              md={12}
              lg={9}
              xl={8}
              xxl={8}
              style={{ border: "1px solid  #f66640", borderRadius: "10px" }}
              className="my-auto"
            >
              <Row className="justify-content-center p-4">
                <Col
                  className="d-flex justify-content-center"
                  md={12}
                  xl={12}
                  xxl={12}
                  sm={12}
                  xs={12}
                >
                  <h3 className="text-center " style={{ fontSize: "24px" }}>
                    Did we miss any company?
                  </h3>
                </Col>
                <Col
                  className="d-flex justify-content-center"
                  md={12}
                  xl={12}
                  xxl={12}
                  sm={12}
                  xs={12}
                >
                  <p
                    className="text-muted"
                    style={{ textAlign: "center", fontSize: "18px" }}
                  >
                    Let us know here and we’ll add it!
                  </p>
                </Col>

                <Col
                  className="d-flex justify-content-center"
                  md={12}
                  xl={12}
                  xxl={12}
                  sm={12}
                  xs={12}
                >
                  <button
                    onClick={() => setModalShow(true)}
                    style={{
                      width: "130px",
                      height: "40px",
                      backgroundColor: "#f66640",
                      color: "white",
                      bordeRadius: "8px",
                      fontWeight: "normal",
                      border: "0 none",
                      borderRadius: "5px",
                    }}
                  >
                    Let us know
                  </button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      ) : (
        <Row className="justify-content-center" style={{ marginTop: "250px" }}>
          <Col md={2} sm={2} xs={2}>
            <Spinner animation="border" style={{ color: "#f66640" }} />
          </Col>
        </Row>
      )}

      <MyVerticallyCenteredModal
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    </div>
  );
}

export default Categories;

export const getServerSideProps = async (context) => {
  const category = (await mongoapi("get", `categories/${context.params.id}`))
    .data.data;
  const cookie = await context.req.cookies["userToken"];
  const user = jwt.decode(cookie);
  const currentUserLikes = await callBackendApi({
    method: "get",
    url: "/like",
    params: { email: user?.email },
  });
  const likeData = currentUserLikes.data.data;

  console.log(currentUserLikes.data.data);

  let likeArray = [];
  let vendorsData;

  const companies = category.vendors.map(({ vendorID }) => {
    return vendorID;
  });

  if(user){
    likeArray = likeData.map(like => like.vendorId)
    vendorsData = companies.map(company => {
      if (likeArray.includes(company._id)) {
        company.liked = true
      }else{
        company.liked = false
      }
      return company
    })
  } else {
  }

  vendorsData = companies;

  return {
    props: {
      category,
      companies: vendorsData.sort((a, b) => b.countLikes - a.countLikes),
    },
  };
};
